import type { SVGProps } from "react";

export const ClockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}>
    <path
      fill="currentColor"
      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm-.5 2a.5.5 0 0 1 .492.41L8 3.5V8h2.5a.5.5 0 0 1 .09.992L10.5 9h-3a.5.5 0 0 1-.492-.41L7 8.5v-5a.5.5 0 0 1 .5-.5Z"
    />
  </svg>
);
